import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MaterialModule } from '../../material/material.module';
import { CustomDropdownModule } from '../custom-dropdown/custom-dropdown.module';
import { CompleteVoayageComponent } from './complete-voayage.component';



@NgModule({
  declarations: [CompleteVoayageComponent],
  imports: [
    CommonModule,
    MaterialModule,
    CustomDropdownModule,
    MatIconModule,
    FormsModule,

    ReactiveFormsModule,
  ],
   exports: [
        CompleteVoayageComponent
    
        
    
      ]
})
export class CompleteVoayageModule { }
